import 'whatwg-fetch';
import {
    indexFamilyMember,
    setIndexFamilyMember,
    setNewFamilyMember,
    add_msg
} from '../../actions'
import fetchConfig from '../fetchConfig'
import SystemModal from '../SystemModal/SystemModal'
import fetchExtend from "../fetchExtend";


export default {
    index: (dispatch) => {
        SystemModal.showLoadMsg(dispatch);
        fetch(API_SERVER+'/api/v1/family_members', {
            credentials: 'same-origin',
            method: 'GET',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                SystemModal.closeMsg(dispatch);
                dispatch(setIndexFamilyMember(json))
                // dispatch(hideSpinner());
            })
            .catch(function (error) {
                SystemModal.showLoadErrorMsg(dispatch)
            });
    },
    new: (dispatch) => {
        fetch(API_SERVER+'/api/v1/family_members/new', {
            credentials: 'same-origin',
            method: 'GET',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                dispatch(setNewFamilyMember(json))
            })
            .catch(function (error) {
            });
    },
    create: (dispatch, payload) => {
        SystemModal.showSaveMsg(dispatch);
        let payloadValue = payload.toJS();
        let formData = new FormData();
        for (var key in payloadValue){
            formData.append("family_member[" + key + "]", payloadValue[key]);
        }
        fetch(API_SERVER+'/api/v1/family_members', {
            credentials: 'same-origin',
            method: 'POST',
            headers: new fetchConfig().fetchConfigHeaders(),
            body: formData
            // body: JSON.stringify( { transfer_student: payloadValue } )
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then(() => {
                add_msg('儲存完成');
                indexFamilyMember(dispatch)
            })
            .catch(function (error) {
                SystemModal.showSaveErrorMsg(dispatch)
            });
    },
    destroy: (dispatch, payload) => {
        SystemModal.showDestroyMsg(dispatch);
        fetch(API_SERVER+'/api/v1/family_members/' + payload, {
            credentials: 'same-origin',
            method: 'DELETE',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then(() => {
                indexFamilyMember(dispatch)
            })
            .catch(function (error) {
                SystemModal.showDestroyErrorMsg(dispatch);
            });
    },
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/FamilyMember/FamilyMember.jsx